var name = "@bilibili/bili-mirror";
var version = "1.6.23";
var files = [
	"dist",
	"package.json",
	"README.md"
];
var description = "bilibili-前端上报、性能、错误监控sdk,";
var main = "dist/cjs/src/index.js";
var cjs = "dist/cjs/src/index.js";
var module = "dist/esm/src/index.js";
var umd = "dist/umd/biliMirror.umd.mini.js";
var types = "dist/@types/biliMirror.d.ts";
var sideEffects = false;
var scripts = {
	dev: "cross-env ENV=dev rimraf dist && rollup -c -w",
	build: "cross-env ENV=production rimraf dist && rollup -c rollup.config.js",
	"docs:dev": "vitepress dev docs",
	"docs:build": "vitepress build docs",
	"docs:serve": "vitepress serve docs",
	"docs:preview": "vitepress preview docs"
};
var author = "yuguangchao";
var license = "LICENSE";
var devDependencies = {
	"@babel/core": "^7.18.10",
	"@babel/plugin-proposal-class-properties": "^7.18.6",
	"@babel/plugin-proposal-object-rest-spread": "^7.20.7",
	"@babel/plugin-transform-runtime": "^7.16.4",
	"@babel/preset-env": "^7.12.1",
	"@babel/runtime": "^7.16.3",
	"@changesets/cli": "^2.26.2",
	"@rollup/plugin-eslint": "^8.0.1",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-typescript": "^6.1.0",
	"@types/node": "^17.0.31",
	"@typescript-eslint/parser": "^4.14.0",
	"babel-plugin-external-helpers": "^6.22.0",
	"babel-preset-latest": "^6.24.1",
	"cross-env": "^7.0.3",
	eslint: "^7.32.0",
	less: "^4.1.2",
	rimraf: "^3.0.2",
	rollup: "^2.79.1",
	"rollup-plugin-babel": "^4.4.0",
	"rollup-plugin-banner": "^0.2.1",
	"rollup-plugin-clear": "^2.0.0",
	"rollup-plugin-commonjs": "^10.1.0",
	"rollup-plugin-dts": "^3.0.2",
	"rollup-plugin-livereload": "^2.0.0",
	"rollup-plugin-node-builtins": "^2.1.2",
	"rollup-plugin-node-globals": "^1.4.0",
	"rollup-plugin-node-resolve": "^5.2.0",
	"rollup-plugin-serve": "^1.1.0",
	"rollup-plugin-terser": "^7.0.2",
	"rollup-plugin-typescript2": "^0.30.0",
	tslib: "^2.3.1",
	typescript: "^4.0.5",
	vitepress: "^1.0.0-rc.4",
	vue: "^3.3.4"
};
var dependencies = {
	"@bilibili/cross-scripts": "^1.0.5",
	"@bilibili/dynamic-import": "^0.0.7",
	"@rollup/plugin-babel": "^6.0.4",
	"error-stack-parser": "^2.1.4",
	"web-vitals": "^3.1.1"
};
var externalDocs = "https://neo-pages.bilibili.com/bili-utils/bili-mirror/";
var pkg = {
	name: name,
	version: version,
	files: files,
	description: description,
	main: main,
	cjs: cjs,
	module: module,
	umd: umd,
	types: types,
	sideEffects: sideEffects,
	scripts: scripts,
	author: author,
	license: license,
	devDependencies: devDependencies,
	dependencies: dependencies,
	externalDocs: externalDocs
};

export { author, cjs, pkg as default, dependencies, description, devDependencies, externalDocs, files, license, main, module, name, scripts, sideEffects, types, umd, version };
